/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TokenObtainPair
 */
export interface TokenObtainPair {
    /**
     * 
     * @type {string}
     * @memberof TokenObtainPair
     */
    readonly access: string;
    /**
     * 
     * @type {string}
     * @memberof TokenObtainPair
     */
    readonly refresh: string;
}

/**
 * Check if a given object implements the TokenObtainPair interface.
 */
export function instanceOfTokenObtainPair(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "access" in value;
    isInstance = isInstance && "refresh" in value;

    return isInstance;
}

export function TokenObtainPairFromJSON(json: any): TokenObtainPair {
    return TokenObtainPairFromJSONTyped(json, false);
}

export function TokenObtainPairFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenObtainPair {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'access': json['access'],
        'refresh': json['refresh'],
    };
}

export function TokenObtainPairToJSON(value?: TokenObtainPair | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

